import type { BookLanguageRow } from '../../Settings/lists/singleTableListSupport';
import { bookLanguageRowIsActive } from '../../Settings/lists/singleTableListSupport';
import { defaultPageLangContent } from './model';
import type { BookFormDraft } from './types';

/** Languages that count for page text / publish checks: on in the book and still active in Book languages settings. */
export function effectiveEnabledLangIdsForBookPages(
  draft: BookFormDraft,
  displayBookLanguages?: BookLanguageRow[],
): string[] {
  if (displayBookLanguages && displayBookLanguages.length > 0) {
    return displayBookLanguages
      .filter((l) => bookLanguageRowIsActive(l) && draft.language_enabled[l.id])
      .map((l) => l.id);
  }
  return Object.entries(draft.language_enabled)
    .filter(([, on]) => on)
    .map(([id]) => id);
}

/** Per-page rules used for step-4 completion and for save when the book is published. */
export function findFirstBookPagesMandatoryError(
  draft: BookFormDraft,
  displayBookLanguages?: BookLanguageRow[],
): string | null {
  const enabledLangIds = effectiveEnabledLangIdsForBookPages(draft, displayBookLanguages);
  const sortedPages = [...draft.pages].sort((a, b) => a.page_number - b.page_number);

  for (const p of sortedPages) {
    const hasPageImage = Boolean(p.image_file || p.image_path.trim());
    if (!hasPageImage) {
      return `Хуудас № ${p.page_number}: зургийн файл эсвэл S3 түлхүүр заавал.`;
    }
    for (const langId of enabledLangIds) {
      const lc = p.byLang[langId] ?? defaultPageLangContent();
      if (!lc.full_text.trim()) {
        return `Хуудас № ${p.page_number}: «${langId}» хэл дээр хуудасны бүтэн текст заавал бөглөнө.`;
      }
    }
  }
  return null;
}

/** Step «Хуудсууд» (алхам 5): дор хаяж нэг хуудас, бүх хуудсанд заавал талбар бүрэн. */
export function areBookPagesStepComplete(
  draft: BookFormDraft,
  displayBookLanguages?: BookLanguageRow[],
): boolean {
  if (draft.pages.length === 0) return false;
  return findFirstBookPagesMandatoryError(draft, displayBookLanguages) === null;
}
